const language = {
  state: {
    appLanguage: localStorage.getItem("appLanguage") || "vi"
  },
  mutations: {
    setAppLanguage(state, language) {
      state.appLanguage = language;
      localStorage.setItem("appLanguage", language);
    }
  }
};

export default language;
